import { Check, Play, RotateCcw, type LucideIcon } from "lucide-react";

import {
  TASK_STATUSES,
  type TaskStatus,
} from "@/lib/project-types";

export const TASK_STATUS_LABEL_KEYS: Record<TaskStatus, string> = {
  open: "projects:taskStatusOpen",
  in_progress: "projects:taskStatusInProgress",
  on_hold: "projects:taskStatusOnHold",
  done: "projects:taskStatusDone",
  cancelled: "projects:taskStatusCancelled",
};

export const TASK_STATUS_DOT_CLASSES: Record<TaskStatus, string> = {
  // Keep Open out of the blue-green range so it remains distinct from Done.
  open: "bg-purple-600 dark:bg-purple-500",
  in_progress: "bg-amber-500",
  on_hold: "bg-red-500 dark:bg-red-400",
  done: "bg-emerald-500",
  cancelled: "bg-slate-400",
};

export const TASK_STATUS_SHAPE_CLASSES: Record<TaskStatus, string> = {
  open: "",
  in_progress: "",
  on_hold: "rounded-none",
  done: "",
  cancelled: "",
};

export interface TaskStatusTransition {
  nextStatus: TaskStatus;
  labelKey: string;
  icon: LucideIcon;
}

const TASK_STATUS_TRANSITIONS: Record<TaskStatus, TaskStatusTransition> = {
  open: { nextStatus: "in_progress", labelKey: "projects:taskStatusStart", icon: Play },
  in_progress: { nextStatus: "done", labelKey: "projects:taskStatusMarkDone", icon: Check },
  on_hold: { nextStatus: "in_progress", labelKey: "projects:taskStatusResume", icon: Play },
  done: { nextStatus: "open", labelKey: "projects:taskStatusReopen", icon: RotateCcw },
  cancelled: { nextStatus: "open", labelKey: "projects:taskStatusReopen", icon: RotateCcw },
};

export function getTaskStatusTransition(status: TaskStatus): TaskStatusTransition {
  return TASK_STATUS_TRANSITIONS[status];
}

export function isTaskStatus(value: string): value is TaskStatus {
  return (TASK_STATUSES as readonly string[]).includes(value);
}
